import { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  es: {
    nav: { home: "Inicio", treatments: "Tratamientos", about: "Sobre nosotros", blog: "Blog", faq: "Preguntas", contact: "Contacto", book: "Pide tu cita", myAppt: "Mi cita", myPanel: "Mi panel" },
    footer: {
      contact: "Contacto", hours: "Horarios", legal: "Legal",
      tagline: "Odontología sin dolor en el corazón de Armenia",
      copyright: "Todos los derechos reservados.",
      legalPrivacy: "Aviso legal, privacidad y cookies",
      faq: "Preguntas frecuentes",
      pqrs: "PQRS · Peticiones, quejas y sugerencias",
      myAppointment: "Consultar mi cita",
      blog: "Blog",
    },
    hero: {
      badge: "Odontología sin dolor · Armenia, Quindío",
      title1: "Odontología",
      title2: "sin dolor",
      title3: ", cerca, cálida y sin sorpresas.",
      subtitle: "Atención cercana para adultos y niños, con explicaciones claras y un plan de tratamiento pensado para ti.",
      cta: "Agenda tu valoración",
      call: "Llamar",
      trust1_title: "1 a 1", trust1_note: "Consulta unipersonal, sin rotación de pacientes",
      trust2_title: "Claridad desde el inicio", trust2_note: "Te explicamos las opciones y el presupuesto antes de comenzar",
      trust3_title: "Diagnóstico con imágenes", trust3_note: "Usamos herramientas de diagnóstico para valorar tu caso con mayor claridad",
    },
    common: { readMore: "Leer", back: "Volver", loading: "Cargando…", pendingValidation: "Contenido pendiente de validación profesional.", minRead: "min de lectura", viewAll: "Ver todos", viewDetail: "Ver detalle", reserveNow: "Reservar", learnMore: "Ver más", send: "Enviar", sending: "Enviando…", required: "obligatorio", cancel: "Cancelar" },
    booking: { pageTitle: "Reserva tu cita", pageSubtitle: "Atendemos con cita previa de lunes a viernes de 8:00 a. m. a 6:00 p. m. y sábados de 8:00 a. m. a 1:30 p. m.", confirm: "Solicitar cita", confirming: "Confirmando…" },
    home: {
      treatmentsEyebrow: "Tratamientos",
      treatmentsTitle: "Seis áreas, un mismo criterio clínico.",
      treatmentsViewAll: "Ver todos →",
      confidenceEyebrow: "Confianza",
      confidenceTitle: "Transparencia antes que promesa.",
      confidenceBody: "Publicamos únicamente lo que podemos verificar. Los datos de colegiación, años de experiencia, testimonios y casos clínicos se irán incorporando a medida que sean validados por la profesional responsable.",
      confidenceNote: "Contenido clínico y testimonios pendientes de validación profesional.",
      confCard1_k: "1 a 1", confCard1_v: "Consulta unipersonal, sin rotación de pacientes.",
      confCard2_k: "0 sorpresas", confCard2_v: "Presupuesto escrito antes de iniciar.",
      confCard3_k: "24/7", confCard3_v: "WhatsApp directo para dudas post-tratamiento.",
      confCard4_k: "Rx digital", confCard4_v: "Diagnóstico con imagen actualizada.",
      finalCtaTitle: "¿Lista, listo para agendar?",
      finalCtaBody: "Elige día, hora y motivo. Recibirás confirmación por correo y podrás modificarla escribiéndonos por WhatsApp.",
      finalCtaBook: "Reservar cita",
      finalCtaDoubt: "Solo tengo una duda",
    },
    heroCta: { primary: "Agenda tu valoración", secondary: "Llamar" },
    contact: {
      eyebrow: "Contacto", title: "Hablemos.", body: "Escríbenos para agendar, resolver dudas o pedir un segundo diagnóstico. También puedes reservar directamente en el calendario.",
      whatsappOpen: "Abrir WhatsApp",
      fullName: "Nombre completo", email: "Correo", phone: "Teléfono", message: "Mensaje",
      submit: "Enviar mensaje", sending: "Enviando…",
      sentOk: "Mensaje enviado. Te responderemos a la brevedad.",
      sentErr: "No se pudo enviar el mensaje. Intenta por WhatsApp.",
      directionsBtn: "Cómo llegar en Google Maps",
      reviewsBtn: "Ver reseñas en Google",
      howToArrive: "Cómo llegar",
      reviewsNote: "Puntuación tomada del perfil público de Google Business. Referencia externa, no representa nuestra propia estadística.",
      googleReviews: "reseñas Google",
      consentBefore: "Autorizo el tratamiento de mis datos personales según la ",
      consentLink: "política de privacidad",
      consentAfter: " para que puedan responderme.",
      consentRequired: "Por favor acepta el tratamiento de datos para continuar.",
      captchaLabel: "Verificación",
      captchaRefresh: "Cambiar operación",
      captchaCorrect: "Correcto",
      captchaIncorrect: "Incorrecto",
      captchaError: "Verificación incorrecta. Resuelve la operación matemática.",
      captchaAria: "Resultado de {a} más {b}",
    },
    about: {
      eyebrow: "Sobre nosotros",
      title_start: "Un consultorio donde ",
      title_highlight: "tu tiempo importa",
      title_end: ".",
      body: "Katia Falón Odontología es una consulta boutique en Armenia, Quindío. Un paciente por franja horaria, presupuestos claros y planes que se explican antes de iniciar.",
      block1_title: "Formación profesional",
      block1_body: "Dra. Katia Falón — Odontóloga egresada de la Universidad Autónoma de Manizales (Caldas). Especialista en Gerencia de Salud por la Universidad del Área Andina (Pereira). Diplomado en «Biomimética y Estética en el Sector Anterior» avalado por la Universidad del Valle.",
      block2_title: "Equipo",
      block2_body: "Trabajamos con auxiliares de higiene y esterilización y con una red de profesionales externos para tratamientos que requieren especialidad (endodoncia, cirugía maxilofacial, radiología).",
      block3_title: "Enfoque clínico",
      block3_body: "Nuestra especialidad es la odontología sin dolor: anestesia electrónica computarizada y, cuando el caso lo requiere, sedación consciente supervisada. Trabajamos odontología conservadora y estética con radiografía digital y protocolos de bioseguridad certificados.",
      pendingBadge: "pendiente de validación",
      teamEyebrow: "Nuestro equipo",
      teamTitle: "Profesionales que atienden en el consultorio.",
      team1_name: "Dra. Katia Jimena Falón Uribe",
      team1_role: "Odontóloga · Directora clínica",
      team2_name: "Dra. Janeth Correa",
      team2_role: "Ortodoncista y ortopedista",
      team3_name: "Dr. Daniel Moscoso",
      team3_role: "Odontólogo",
    },
    faq: {
      eyebrow: "Preguntas frecuentes", title: "Todo lo que quisiste preguntar.",
      body: "Respuestas honestas y verificables. Si falta algo, escríbenos: lo añadimos.",
    },
    treatments: {
      eyebrow: "Tratamientos",
      title: "Odontología con nombre, apellido y responsable clínico.",
      body: "Cada tratamiento se planifica en consulta y se te entrega por escrito antes de iniciar. Precios orientativos disponibles bajo valoración — nunca cobros sorpresa.",
    },
    blog: {
      eyebrow: "Recursos", title: "Blog",
      body: "Escribimos sobre lo que atendemos a diario. Contenido pendiente de validación profesional en la mayoría de casos.",
      empty: "Aún no hay entradas publicadas.",
      readingTime: "4 min de lectura",
      backToBlog: "Blog",
      bookCta: "Reserva tu cita",
    },
    lang: { es: "ES", en: "EN" },
  },
  en: {
    nav: { home: "Home", treatments: "Treatments", about: "About us", blog: "Blog", faq: "FAQ", contact: "Contact", book: "Book appointment", myAppt: "My visit", myPanel: "My panel" },
    footer: {
      contact: "Contact", hours: "Hours", legal: "Legal",
      tagline: "Pain-free dentistry in the heart of Armenia",
      copyright: "All rights reserved.",
      legalPrivacy: "Legal notice, privacy and cookies",
      faq: "Frequently asked questions",
      pqrs: "PQRS · Requests, complaints and suggestions",
      myAppointment: "Check my appointment",
      blog: "Blog",
    },
    hero: {
      badge: "Pain-free dentistry · Armenia, Quindío",
      title1: "Pain-free",
      title2: "dentistry",
      title3: ", close, warm and without surprises.",
      subtitle: "Close, warm care for adults and children — clear explanations and a treatment plan tailored to you.",
      cta: "Book your check-up",
      call: "Call",
      trust1_title: "1 to 1", trust1_note: "One-on-one consultation, no patient rotation",
      trust2_title: "Clarity from the start", trust2_note: "We explain the options and the budget before starting",
      trust3_title: "Imaging-supported diagnosis", trust3_note: "We use diagnostic tools to assess your case with more clarity",
    },
    common: { readMore: "Read", back: "Back", loading: "Loading…", pendingValidation: "Clinical content pending professional validation.", minRead: "min read", viewAll: "See all", viewDetail: "See details", reserveNow: "Book", learnMore: "Learn more", send: "Send", sending: "Sending…", required: "required", cancel: "Cancel" },
    booking: { pageTitle: "Pick day and time.", pageSubtitle: "Mon-Fri 8am-6pm and Saturdays 8am-1:30pm (urgent care). Each appointment is 30 minutes.", confirm: "Confirm appointment", confirming: "Confirming…" },
    home: {
      treatmentsEyebrow: "Treatments",
      treatmentsTitle: "Six areas, one clinical standard.",
      treatmentsViewAll: "See all →",
      confidenceEyebrow: "Trust",
      confidenceTitle: "Transparency before promises.",
      confidenceBody: "We only publish what we can verify. Licensing details, years of experience, testimonials and clinical cases will be added as they are validated by the responsible professional.",
      confidenceNote: "Clinical content and testimonials pending professional validation.",
      confCard1_k: "1 to 1", confCard1_v: "One-on-one consultation, no patient rotation.",
      confCard2_k: "0 surprises", confCard2_v: "Written budget before we begin.",
      confCard3_k: "24/7", confCard3_v: "Direct WhatsApp for post-treatment questions.",
      confCard4_k: "Digital X-ray", confCard4_v: "Diagnosis with up-to-date imaging.",
      finalCtaTitle: "Ready to book?",
      finalCtaBody: "Pick a day, time and reason. You'll receive email confirmation and can update it via WhatsApp.",
      finalCtaBook: "Book appointment",
      finalCtaDoubt: "I only have a question",
    },
    heroCta: { primary: "Book your check-up", secondary: "Call" },
    contact: {
      eyebrow: "Contact", title: "Let's talk.", body: "Write to us to book, resolve doubts or request a second opinion. You can also book directly in the calendar.",
      whatsappOpen: "Open WhatsApp",
      fullName: "Full name", email: "Email", phone: "Phone", message: "Message",
      submit: "Send message", sending: "Sending…",
      sentOk: "Message sent. We'll reply shortly.",
      sentErr: "The message could not be sent. Try WhatsApp.",
      directionsBtn: "Get directions on Google Maps",
      reviewsBtn: "See reviews on Google",
      howToArrive: "How to get there",
      reviewsNote: "Rating taken from the public Google Business profile. External reference, not our own metric.",
      googleReviews: "Google reviews",
      consentBefore: "I authorize the processing of my personal data according to the ",
      consentLink: "privacy policy",
      consentAfter: " so you can reply to me.",
      consentRequired: "Please accept the data processing to continue.",
      captchaLabel: "Verification",
      captchaRefresh: "Change operation",
      captchaCorrect: "Correct",
      captchaIncorrect: "Incorrect",
      captchaError: "Verification failed. Solve the math operation.",
      captchaAria: "Result of {a} plus {b}",
    },
    about: {
      eyebrow: "About us",
      title_start: "A clinic where ",
      title_highlight: "your time matters",
      title_end: ".",
      body: "Katia Falón Odontología is a boutique dental practice in Armenia, Quindío. One patient per time slot, clear budgets and plans explained before starting.",
      block1_title: "Professional training",
      block1_body: "Dr. Katia Falón — Dentist trained at Universidad Autónoma de Manizales (Caldas). Specialist in Health Management from Universidad del Área Andina (Pereira). Diploma in «Biomimetics and Aesthetics in the Anterior Sector» endorsed by Universidad del Valle.",
      block2_title: "Team",
      block2_body: "We work with hygiene and sterilization assistants and a network of external professionals for treatments requiring further specialty (endodontics, maxillofacial surgery, radiology).",
      block3_title: "Clinical approach",
      block3_body: "Our specialty is pain-free dentistry: computer-dosed electronic anesthesia and, when the case requires it, supervised conscious sedation. We work conservative and aesthetic dentistry with digital x-ray and certified biosafety protocols.",
      pendingBadge: "pending validation",
      teamEyebrow: "Our team",
      teamTitle: "The professionals who care for you at the clinic.",
      team1_name: "Dr. Katia Jimena Falón Uribe",
      team1_role: "Dentist · Clinical director",
      team2_name: "Dr. Janeth Correa",
      team2_role: "Orthodontist and dentofacial orthopedist",
      team3_name: "Dr. Daniel Moscoso",
      team3_role: "Dentist",
    },
    faq: {
      eyebrow: "Frequently asked questions", title: "Everything you wanted to ask.",
      body: "Honest and verifiable answers. If something is missing, write to us: we'll add it.",
    },
    treatments: {
      eyebrow: "Treatments",
      title: "Dentistry with a name, a surname and a clinical lead.",
      body: "Every treatment is planned in consultation and delivered in writing before starting. Reference prices available upon evaluation — no surprise charges.",
    },
    blog: {
      eyebrow: "Resources", title: "Blog",
      body: "We write about what we treat every day. Content pending professional validation in most cases.",
      empty: "No posts published yet.",
      readingTime: "4 min read",
      backToBlog: "Blog",
      bookCta: "Book your visit",
    },
    lang: { es: "ES", en: "EN" },
  },
};

const I18nCtx = createContext({ lang: "es", setLang: () => {}, t: (k) => k });

function resolve(obj, path) {
  return path.split(".").reduce((o, k) => (o ? o[k] : undefined), obj);
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("kf-lang") || "es");
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const setLang = (l) => { localStorage.setItem("kf-lang", l); setLangState(l); };
  const t = (key) => resolve(DICT[lang], key) ?? resolve(DICT.es, key) ?? key;
  // pick(cmsValue, i18nKey) — prefer CMS in Spanish, fall back to i18n otherwise
  // CMS is edited in a single language (Spanish), so when EN is active we ignore CMS and use t()
  const pick = (cmsValue, key) => (lang === "es" ? (cmsValue || t(key)) : t(key));
  return <I18nCtx.Provider value={{ lang, setLang, t, pick }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
